/* eslint-disable import/no-anonymous-default-export */
import {
  FETCH_FUTURE_SETTINGS,
  FETCH_FUTURE_SETTINGS_ERROR,
  FETCH_FUTURE_STATUS_SETTINGS,
  FETCH_FUTURE_HISTORY_SETTINGS,
  FETCH_FUTURE_ERROR_SETTINGS,
  FETCH_FUTURE_THEME_MODE_SETTINGS,
  FETCH_FUTURE_CREATE_BOT_SETTINGS,
  FETCH_FUTURE_ALL_SETTING,
} from '../types';

const initialState = {
  botListSettings: [],
  botStatusSettings: [],
  botHistorySettings: [],
  botErrorSettings: [],
  // themeMode: '',
  // botSettings: {},
  botShortSettings: {},
  botLongSettings: {},
  success: false,
  loading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_FUTURE_SETTINGS:
      return {
        ...state,
        botListSettings: action.payload,
        success: true,
        loading: false,
      };
    case FETCH_FUTURE_STATUS_SETTINGS:
      return {
        ...state,
        botStatusSettings: action.payload,
        success: true,
        loading: false,
      };
    case FETCH_FUTURE_HISTORY_SETTINGS:
      return {
        ...state,
        botHistorySettings: action.payload,
        success: true,
        loading: false,
      };

    case FETCH_FUTURE_ERROR_SETTINGS:
      return {
        ...state,
        botErrorSettings: action.payload,
        success: true,
        loading: false,
      };

    case FETCH_FUTURE_THEME_MODE_SETTINGS:
      return {
        ...state,
        themeMode: action.payload,
        success: true,
        loading: false,
      };
    case FETCH_FUTURE_CREATE_BOT_SETTINGS:
      return {
        ...state,
        botSettings: action.payload,
        success: true,
        loading: false,
      };
    case FETCH_FUTURE_ALL_SETTING:
      return {
        ...state,
        botErrorSettings: action.payload?.bot_error_setting,
        botHistorySettings: action.payload?.bot_history_setting,
        botListSettings: action.payload?.bot_list_setting,
        botStatusSettings: action.payload?.bot_status_setting,
        // botSettings: action.payload?.create_bot_setting,
        // themeMode: action.payload?.theme_mode,
        botShortSettings: action.payload?.create_short_bot_setting,
        botLongSettings: action.payload?.create_long_bot_setting,
        success: true,
        loading: false,
      };

    case FETCH_FUTURE_SETTINGS_ERROR:
      return {
        ...state,
        success: false,
        loading: true,
      };

    default:
      return state;
  }
}
